module.exports = __webpack_public_path__ + "fonts/SFProDisplay-Regular.bbd873c5.ttf";